import { EventBus } from "../../../eventbus";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import uniqid from "uniqid";

export default {
  components: {
    CollapseTransition,
  },
  data() {
    return {
      show: false,
      snackbarItems: [],
      activeProcess: null,
    };
  },
  created() {
    EventBus.$on(`snackbar--add`, (data) => {
      this.add(data);
    });

    EventBus.$on(`snackbar--remove`, (id) => {
      this.remove(id);
    });

    EventBus.$on(`snackbar-item--update`, (data) => {
      if (this.activeProcess) {
        if (data.id === this.activeProcess.id) {
          //update this item
          this.activeProcess = { ...this.activeProcess, ...data };
        }
      } else {
        this.activeProcess = data;
      }
    });

    EventBus.$on(`mobile-snackbar--set-show`, (show) => {
      this.show = show;
    });
  },
  methods: {
    add(data) {
      this.snackbarItems.push({
        id: uniqid(),
        ...data,
      });

      if (!this.activeProcess && data.progress !== undefined) {
        this.activeProcess = data;
      }
    },

    remove(id) {
      this.snackbarItems = this.snackbarItems.filter((item) => item.id !== id);

      if (this.activeProcess) {
        if (this.activeProcess.id === id) {
          setTimeout(() => {
            this.activeProcess = null;
          }, 2500);
        }
      }
    },
  },
  watch: {
    activeProcess() {},
  },
};
